<template>
    <admin-layout>

        <template #toolbox>

        </template>

        <app-content-pane class="ml-3">
            <template #title>
                <div class="px-4 pt-3">
                    <h1>Dashboard</h1>
                </div>
                <hr class="mb-0">
            </template>

            <section>
                <div class="px-4 py-3 d-flex align-items-center">
                    <h4 class="mr-auto">Projects</h4>
                    <div class="actions">
                        <a href="#" class="btn btn-light ml-3 border">
                            <img src="/images/icons/edit.svg" class="mr-1" style="max-width: 16px; max-height: 16px; margin-top: -3px" alt="">
                            Bulk Edit
                        </a>
                        <inertia-link :href="route('project.create', {...global_url_params})" class="btn btn-secondary ml-3">+ New Project</inertia-link>
                    </div>
                </div>


<!--                <div class="projects-list table-responsive">-->

<!--                    <table class="table table-hover border-bottom">-->
<!--                        <tbody v-for="i in 2">-->
<!--                        <tr class="">-->
<!--                            <td class="pl-4">-->
<!--                                <inertia-link class="name" :href="route('project.teams')">-->
<!--                                    Making world a better place-->
<!--                                </inertia-link>-->
<!--                            </td>-->
<!--                            <td>-->
<!--                                <div class="btn-group">-->
<!--                                    <span class="btn btn-light border">Class VI - 2021</span>-->
<!--                                    <span class="btn btn-light border">Class XI - 2021</span>-->
<!--                                    <span class="btn btn-light border">Class II - 2020</span>-->
<!--                                    <span class="btn btn-light border">Class V - 2020</span>-->
<!--                                    <span class="btn btn-light border">Class XI - 2021</span>-->
<!--                                    <button class="btn btn-light border">+</button>-->
<!--                                </div>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                            <td class="pl-4">-->
<!--                                <inertia-link class="name" :href="route('project.teams')">-->
<!--                                    Post Covid-19-->
<!--                                </inertia-link>-->
<!--                            </td>-->
<!--                            <td>-->
<!--                                <div class="btn-group">-->
<!--                                    <span class="btn btn-light border">Class II - 2020</span>-->
<!--                                    <span class="btn btn-light border">Class V - 2020</span>-->
<!--                                    <button class="btn btn-light border">+</button>-->
<!--                                </div>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                            <td class="pl-4">-->
<!--                                <inertia-link class="name" :href="route('project.teams')">-->
<!--                                    Play it!-->
<!--                                </inertia-link>-->
<!--                            </td>-->
<!--                            <td>-->
<!--                                <div class="btn-group">-->
<!--                                    <span class="btn btn-light border">Class V - 2020</span>-->
<!--                                    <span class="btn btn-light border">Class XI - 2021</span>-->
<!--                                    <span class="btn btn-light border">Class VI - 2021</span>-->
<!--                                    <button class="btn btn-light border">+</button>-->
<!--                                </div>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                            <td class="pl-4">-->
<!--                                <inertia-link class="name" href="#">-->
<!--                                    Layers of water-->
<!--                                </inertia-link>-->
<!--                            </td>-->
<!--                            <td>-->
<!--                                <div class="btn-group">-->
<!--                                    <button class="btn btn-light border">+</button>-->
<!--                                </div>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                        </tbody>-->
<!--                    </table>-->

<!--                </div>-->
            </section>

            <div class="p-3">
                <button class="btn btn-block btn-light border d-flex">
                        <span class="label">
                            View Past Projects
                        </span>
                </button>
            </div>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import Welcome from '@/Jetstream/Welcome'
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import DashboardToolbox from "@/Components/Toolbox/DashboardToolbox";
import Button from "@/Jetstream/Button";

export default {
    components: {
        Button,
        DashboardToolbox,
        AppContentPane,
        AdminLayout,
        Welcome,
    },
}
</script>

<style lang="scss" scoped>
.projects-list{

    th, td{
        vertical-align: middle;
    }

    .name{
        text-decoration: none;
        color: $dark;
        // font-size: 1rem;
        font-weight: $font-weight-semibold;

        &:hover{
            color: $secondary;
        }
    }
}
</style>
